/**
 * UserAnnotation TanStack DB collection.
 *
 * Mirrors the pattern in `block-collection.ts`: a single `createCollection`
 * that the rest of the viewer subscribes to via `useLiveQuery`. Filtering
 * to a single block (the modal panel's view, or one stream card) is done
 * by the consumer with `where(eq(a.blockId, blockId))` — there's only one
 * source of truth for every annotation, regardless of how many cards are
 * subscribed to it at once.
 *
 * The initial `queryFn` returns an empty array because we don't know
 * which blocks the stream will surface until it pages in. The store's
 * `ensureLoadedForBlocks` helper performs a batched fetch via the new
 * `/v1/user-annotation/by-blocks` endpoint and `writeBatch`-inserts the
 * results into this collection as the stream extends. Optimistic
 * creates/updates/deletes from the same store flow through the same
 * collection so subscribers see them immediately.
 */
import { createCollection } from "@tanstack/react-db";
import { queryCollectionOptions } from "@tanstack/query-db-collection";
import { queryClient } from "./query-client";
const COLLECTION_KEY = ["userAnnotations", "collection"];
export const userAnnotationCollection = createCollection(queryCollectionOptions({
    queryKey: [...COLLECTION_KEY],
    queryClient: queryClient, // minor version mismatch between react-query and query-db-collection's query-core peer (see block-collection.ts for the same cast)
    queryFn: async () => {
        // No seed: the stream warms the collection per-block via
        // `userAnnotationStore.ensureLoadedForBlocks` once `blockCollection`
        // settles. Returning [] here keeps the collection valid before any
        // block is mounted (e.g. on a fresh sign-in or while the stream
        // queries are still in flight).
        return [];
    },
    getKey: (item) => item.id,
}));
export const USER_ANNOTATION_COLLECTION_KEY = COLLECTION_KEY;
